import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { AppGlobals } from '../app.globals';


@Injectable({
  providedIn: 'root'
})
export class TechnicalComponentsService {

  private componentCache = new Map<number, any>();
  private docsCache = new Map<number, any>();

  constructor(private apiService: ApiBaseService, private appGlobals: AppGlobals) { }

  // #region Grid Connections

  async getGridConnectionTechComponentList(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/GetTechComponents', { FilterType: 'gridConnection' }, true, true);
  }

  async getGridConnectionTechComponents(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/GetGridConnectionTechComponents', payload, true, true);
  }

  async addTechComponentToGridConnection(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/AddTechComponentToGridConnection', payload, true, true);
  }

  async editGridConnectionTechComponent(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/EditGridConnectionTechComponent', payload, true, true);
  }

  async removeTechComponentFromGridConnection(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/RemoveTechComponentFromGridConnection', payload, true, true);
  }

  async getAllTechComponentTypes(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/GetAllTechComponentTypes', payload, true, true);
  }

  async getTypeFieldById(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/getTypeFieldById', payload, true, true);
  }

  async getDocsById(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/GetDocsById', payload, true, true);
  }

  async getComponentWithDatafields(payload: any, showLoader = true): Promise<any> {
    const id: number = payload.componentId;

    if (this.componentCache.has(id)) {
      return this.componentCache.get(id);
    }

    let loaderTimer: any = null;
    let loaderShown = false;
    if (!showLoader) {
      loaderTimer = setTimeout(() => {
        loaderShown = true;
        this.appGlobals.ShowGlobalLoader();
      }, 300);
    }

    try {
      const result = await this.apiService.httpRequest('TechnicalComponentsService/GetComponentWithDatafields', payload, true, showLoader);
      this.componentCache.set(id, result);
      return result;
    } finally {
      if (loaderTimer !== null) {
        clearTimeout(loaderTimer);
      }
      if (loaderShown) {
        this.appGlobals.HideGlobalLoader();
      }
    }
  }

  invalidateComponentCache(componentId: number) {
    this.componentCache.delete(componentId);
  }


  

  async getTechComponentTypeDataFields(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/GetTechComponentTypeDataFields', payload, true, true);
  }

  async addComponentTypeDocs(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/AddComponentTypeDocs', payload, true, true);
  }

  async getComponentTypeDocs(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/GetComponentTypeDocs', payload, true, true);
  }

  async getAllComponentTypeDataField(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/GetAllComponentTypeDataField', payload, true, true);
  }

  async editTechComponentTypeDataField(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/EditTechComponentTypeDataField', payload, true, true);
  }

  async deleteTechComponentTypeDocument(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/DeleteTechComponentTypeDocument', payload, true, true);
  }

  async deleteTechComponentType(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/DeleteTechComponentType', payload, true, true);
  }

  async getAllDocumentLink(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/GetAllDocumentLink', payload, true, true);
  }

  async getAllComponentsForGridConnection(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/GetAllComponentsForGridConnection', payload, true, true);
  }

  async getAllComponentsForProject(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/GetAllComponentsForProject', payload, true, true);
  }

  async addTechComponentDocument(formData: FormData): Promise<any> {
    return this.apiService.httpRequestForm('TechnicalComponentsService/AddTechComponentDocument', formData, true, true);
  }

  async addTechComponentDocLink(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/AddTechComponentDocLink', payload, true, true);
  }

  async deleteTechComponentDocLink(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/DeleteTechComponentDocLink', payload, true, true);
  }

  async getAllTechComponentDocLink(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/GetAllTechComponentDocLink', payload, true, true);
  }

  async getTechComponentDocs(payload: any, showLoader = true): Promise<any> {
    const id: number = payload.TechComponentId;

    if (this.docsCache.has(id)) {
      return this.docsCache.get(id);
    }

    let loaderTimer: any = null;
    let loaderShown = false;
    if (!showLoader) {
      loaderTimer = setTimeout(() => {
        loaderShown = true;
        this.appGlobals.ShowGlobalLoader();
      }, 300);
    }

    try {
      const result = await this.apiService.httpRequest('TechnicalComponentsService/GetTechComponentDocs', payload, true, showLoader);
      this.docsCache.set(id, result);
      return result;
    } finally {
      if (loaderTimer !== null) {
        clearTimeout(loaderTimer);
      }
      if (loaderShown) {
        this.appGlobals.HideGlobalLoader();
      }
    }
  }

  invalidateDocsCache(componentId: number) {
    this.docsCache.delete(componentId);
  }

  async downloadAllComponentDocuments(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/DownloadAllComponentDocuments', payload, true, true);
  }

  async downloadAllComponentsDocumentsZipped(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/DownloadAllComponentsDocumentsZipped', payload, true, true);
  }

  async downloadTechComponentDocumentByFileName(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/DownloadTechComponentDocumentByFileName', payload, true, true);
  }



  // #endregion

  async getTechComponents(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/GetTechComponents', payload, true, true);
  }

  async getAllTechDatum(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/GetAllTechDatum', payload, true, true);
  }

  async getComponentWithDataFields(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/GetComponentWithDataFields', payload, true, true);
  }

  async addTechComponent(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/AddTechComponent', payload, true, true);
  }

  async addTechComponentType(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/AddTechComponentType', payload, true, true);
  }

  async addTechComponentTypeData(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/AddTechComponentTypeDataField', payload, true, true);
  }

  async editComponentTypeDocs(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/EditComponentTypeDocs', payload, true, true);
  }

  async addTechComponentDataSheet(payload: any): Promise<any> {
    return this.apiService.httpRequestForm('TechnicalComponentsService/AddTechComponentDataSheet', payload, true, true);
  }

  async addProjectComponentDataSheet(payload: any): Promise<any> {
    return this.apiService.httpRequestForm('TechnicalComponentsService/AddProjectComponentDataSheet', payload, true, true);
  }


  async addGridConnectionComponentDataSheet(payload: any): Promise<any> {
    return this.apiService.httpRequestForm('TechnicalComponentsService/AddGridConnectionComponentDataSheet', payload, true, true);
  }


  async getTechnicalDocument(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/GetTechnicalDocument', payload, true, true);
  }

  async removeGridConnectionComponentDatasheet(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/RemoveGridConnectionComponentDatasheet', payload, true, true);
  }

  

  async editTechComponent(payload: any): Promise<any> {
    const result = await this.apiService.httpRequest('TechnicalComponentsService/EditTechComponent', payload, true, true);
    if (!result.hasError) {
      this.invalidateComponentCache(payload.ComponentItem.ComponentId);
      this.invalidateDocsCache(payload.ComponentItem.ComponentId);
    }
    return result;
  }

  async editTechComponentType(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/EditTechComponentType', payload, true, true);
  }

  async getProjectTechComponents(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/GetProjectTechComponents', payload, true, true);
  }

  async writeProjectTechComponentNotes(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/WriteProjectTechComponentNotes', payload, true, true);
  }

  async addTechComponentToProject(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/AddTechComponentToProject', payload, true, true);
  }

  async editTechComponentToProject(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/EditTechComponentToProject', payload, true, true);
  }

  async removeTechComponentFromProject(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/RemoveTechComponentFromProject', payload, true, true);
  }

  async deleteTechComponentTypeDataField(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/DeleteTechComponentTypeDataField', payload, true, true);
  }

  async deleteDatafieldCheck(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/DeleteDatafieldCheck', payload, true, true);
  }

  async deleteDocumentTypeCheck(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/DeleteDocumentTypeCheck', payload, true, true);
  }


  async getCompanies(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/GetCompanies', payload, true, true);
  }

  async removeTechComponentDataSheet(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/RemoveTechComponentDataSheet', payload, true, true);
  }

  async saveProjectComponents(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/SaveProjectComponents', payload, true, true);
  }

  async deleteTechComponent(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/DeleteTechComponent', payload, true, true);
  }

  /////// MAIL TEMPLATE CALLS

  async writeMailTemplate(payload: any): Promise<any> {
    return this.apiService.httpRequest('TechnicalComponentsService/WriteMailTemplate', payload, true, true);
  }

}